import NotificationsItem from './NotificationsItem';

export default NotificationsItem;
